<div class="grid grid-cols-3 gap-7.5">
  <div class="col-span-2 grid h-28 grid-cols-4 rounded border p-4">
    <div class="flex items-center border-r font-bold">Activities by Driver</div>

    @if ((analyticsSectionLoading$ | async) === false) {
      @if (forecastQuery.select('activitiesByDriver') | async; as activitiesByDriver) {
        <div class="col-span-3 flex flex-col justify-between gap-3 pl-5 tabular-nums">
          <div class="flex h-6 w-full text-xs font-bold text-white">
            @if (activitiesByDriver.Time.percentage; as percentage) {
              <div
                class="rounded-l bg-aux-blue px-2 py-1 text-center"
                [ngStyle]="{ flexGrow: percentage }"
                [ngClass]="{ 'rounded-r': percentage === 100 }"
              >
                {{ percentage }}%
              </div>
            }
            @if (activitiesByDriver.Patient.percentage; as percentage) {
              <div
                class="bg-aux-green px-2 py-1 text-center"
                [ngStyle]="{ flexGrow: percentage }"
                [ngClass]="{ rounded: percentage === 100 }"
              >
                {{ percentage }}%
              </div>
            }
            @if (activitiesByDriver.Site.percentage; as percentage) {
              <div
                class="rounded-r bg-aux-blue-light px-2 py-1 text-center"
                [ngStyle]="{ flexGrow: percentage }"
                [ngClass]="{ 'rounded-l': percentage === 100 }"
              >
                {{ percentage }}%
              </div>
            }
          </div>

          <div class="grid grid-cols-3">
            <div>
              <div class="mb-2 mr-1 flex items-center justify-center">
                <div class="mr-2 h-4 w-4 rounded-full bg-aux-blue"></div>
                <div class="text-xs">Time</div>
              </div>
              <div class="mb-2 mr-1 flex items-center justify-center text-sm font-bold">
                {{ activitiesByDriver.Time.costStr }}
              </div>
            </div>

            <div>
              <div class="mb-2 mr-1 flex items-center justify-center">
                <div class="mr-2 h-4 w-4 rounded-full bg-aux-green"></div>
                <div class="text-xs">Patient</div>
              </div>
              <div class="mb-2 mr-1 flex items-center justify-center text-sm font-bold">
                {{ activitiesByDriver.Patient.costStr }}
              </div>
            </div>

            <div>
              <div class="mb-2 mr-1 flex items-center justify-center">
                <div class="mr-2 h-4 w-4 rounded-full bg-aux-blue-light"></div>
                <div class="text-xs">Site</div>
              </div>

              <div class="mb-2 mr-1 flex items-center justify-center text-sm font-bold">
                {{ activitiesByDriver.Site.costStr }}
              </div>
            </div>
          </div>
        </div>
      }
    } @else {
      <ng-container *ngTemplateOutlet="analyticsSectionLoader" />
    }
  </div>

  <div class="flex items-stretch justify-between border">
    @if ((analyticsSectionLoading$ | async) === false) {
      <div class="flex items-center bg-aux-gray-light p-3 text-aux-blue-dark">
        Unforecasted Costs
      </div>

      <div class="flex items-center p-3 text-xl text-aux-blue-dark">
        @if (forecastQuery.select('unforecastedCosts') | async) {
          <aux-icon name="AlertTriangle" class="mr-3 flex-shrink-0 text-aux-red-dark" />
        }
        {{ forecastQuery.select('unforecastedCosts') | async | money: orgCurrency }}
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="analyticsSectionLoader" />
    }
  </div>
</div>

<ng-template #analyticsSectionLoader>
  <div class="col-span-3 flex w-full items-center justify-center">
    <div class="spinner m-auto border-4"></div>
  </div>
</ng-template>
